export default [
  {
    path: "/acl",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "acl_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "acl", to: "acl_list" }],
          permission: "roles:view",
          title: "acl",
        },
      },
      {
        name: "acl_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "acl", to: "acl_list" }],
          permission: "roles:create",
          title: "acl - Cadastro",
        },
      },
      {
        name: "acl_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "acl", to: "acl_list" }],
          permission: "roles:edit",
          title: "acl - Edição",
        },
      },
    ],
  },
];
